import moment from "moment";

export const cloneAndSortDescending = (range) => {
	const clonedRange = [...range];
	clonedRange.sort((a, b) => new moment(b.startdate).format("YYYYMMDD") - new moment(a.startdate).format("YYYYMMDD"));

	return clonedRange;
};
